var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.cssClass,attrs:{"src":_vm.path,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }